// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27%2364748b%27%3E%3Cpath d=%27M4 6a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm2 0v12h12V6H6zm4 2a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1zm4 0a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DashboardPage Styles */

.dashboard-page {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1.5rem;
}

@media (min-width: 640px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .stats-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.stat-card {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.25rem;
  background-color: var(--surface-light);
  border-radius: var(--radius-xl);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
}

.stat-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-icon .material-symbols-outlined {
  font-size: 24px;
}

.stat-icon-primary {
  background-color: var(--primary-light);
  color: var(--primary);
}

.stat-icon-blue {
  background-color: #dbeafe;
  color: #2563eb;
}

.stat-icon-purple {
  background-color: #f3e8ff;
  color: #9333ea;
}

.stat-icon-green {
  background-color: #dcfce7;
  color: #16a34a;
}

.stat-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.stat-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-sub);
  margin: 0;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-main);
  margin: 0;
}

.rank-cell {
  font-weight: 700;
  color: var(--text-sub);
  width: 4rem;
  text-align: center;
}

.books-ranking-table th:nth-child(1) { width: 6%; }
.books-ranking-table th:nth-child(2) { width: 8%; }
.books-ranking-table th:nth-child(3) { width: 40%; }
.books-ranking-table th:nth-child(4) { width: 28%; }
.books-ranking-table th:nth-child(5) { width: 18%; }

.reader-count-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--primary);
}

.reader-count-badge .material-symbols-outlined {
  font-size: 16px;
}

/* Card */
.card {
  background-color: var(--surface-light);
  border-radius: var(--radius-xl);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background-color: var(--slate-50);
  border-bottom: 1px solid var(--border-color);
  flex-wrap: wrap;
  gap: 1rem;
}

.card-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-main);
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.filter-tabs {
  display: flex;
  gap: 0.25rem;
  background-color: var(--slate-100);
  padding: 0.25rem;
  border-radius: var(--radius-lg);
}

.filter-tab {
  padding: 0.375rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--text-sub);
  background-color: transparent;
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.filter-tab:hover {
  color: var(--text-main);
  background-color: rgba(255, 255, 255, 0.5);
}

.filter-tab.active {
  color: var(--primary);
  background-color: var(--surface-light);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-wrapper .material-symbols-outlined {
  position: absolute;
  left: 0.75rem;
  color: var(--text-sub);
  font-size: 20px;
}

.search-input {
  width: 16rem;
  padding: 0.5rem 0.75rem 0.5rem 2.5rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  font-size: 0.875rem;
  background-color: var(--surface-light);
}

.search-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 2px var(--primary-light);
}

/* Table */
.table-container {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.table thead {
  background-color: var(--slate-50);
  border-bottom: 1px solid var(--border-color);
}

.table th {
  padding: 1rem 1.5rem;
  text-align: left;
  font-weight: 600;
  color: var(--text-sub);
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

/* Column widths for Dashboard */
.table th:nth-child(1) { width: 15%; } /* Borrower Name - large, multi-line */
.table th:nth-child(2) { width: 8%; }  /* Cover - compact, fixed */
.table th:nth-child(3) { width: 40%; } /* Title - largest, multi-line */
.table th:nth-child(4) { width: 12%; } /* Borrow Date - compact */
.table th:nth-child(5) { width: 12%; } /* Return Date - compact */
.table th:nth-child(6) { width: 8%; }  /* Status - compact */

/* Table row - consistent height */
.table tbody tr {
  transition: background-color var(--transition-fast);
}

.table tbody tr:hover {
  background-color: var(--background-light);
}

/* Book cover column - center the image */
.book-cover-column {
  text-align: center;
  vertical-align: middle !important;
  padding: 0.75rem 0.75rem !important;
}

.book-cover-inline {
  width: 48px;
  height: 64px;
  object-fit: cover;
  border-radius: var(--radius-md);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 1px solid var(--border-color);
}

.book-cover-placeholder-inline {
  width: 48px;
  height: 64px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.book-cover-placeholder-inline .material-symbols-outlined {
  font-size: 24px;
  color: #64748b;
}

.book-cover-column .book-cover-inline,
.book-cover-column .book-cover-placeholder-inline {
  margin: 0 auto;
  display: block;
}

/* Book title column - allow wrapping */
.book-title-column {
  white-space: normal;
  vertical-align: middle;
  max-width: 300px;
}

.book-title-text {
  word-break: break-word;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.table td {
  padding: 0.75rem 1.25rem;
  border-top: 1px solid var(--border-color);
  color: var(--text-main);
  vertical-align: middle;
  height: 80px;
  box-sizing: border-box;
}

/* Compact date cells */
.table td:nth-child(4),
.table td:nth-child(5) {
  padding: 0.75rem 1rem;
  font-size: 0.8125rem;
  white-space: nowrap;
}

/* Borrower Name and Title cells - allow wrapping */
.table td:nth-child(1),
.table td:nth-child(3) {
  white-space: normal;
  vertical-align: middle;
}

/* Cover and Status cells - compact */
.table td:nth-child(2),
.table td:nth-child(6) {
  white-space: nowrap;
}

/* Borrower Cell */
.borrower-cell {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 500;
  height: 100%;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
}

.avatar {
  background-color: #e0e7ff;
  color: #4338ca;
}

/* Status Badge */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.625rem;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: var(--radius-full);
  border: 1px solid;
}

.status-borrowed,
.status-active {
  background-color: #fee2e2;
  color: #991b1b;
  border-color: #fca5a5;
}

.status-returned {
  background-color: #dcfce7;
  color: #166534;
  border-color: #86efac;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: currentColor;
}

/* Table Footer */
.table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background-color: var(--slate-50);
  border-top: 1px solid var(--border-color);
}

.pagination-info {
  font-size: 0.875rem;
  color: var(--text-sub);
  margin: 0;
}

.pagination-info strong {
  color: var(--text-main);
  font-weight: 600;
}

.pagination-buttons {
  display: flex;
  gap: 0.5rem;
}

/* Responsive */
@media (max-width: 768px) {
  .dashboard-page {
    gap: 1rem;
    padding: 0.5rem;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .card-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .header-actions {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }

  .filter-tabs {
    width: 100%;
  }

  .filter-tab {
    flex: 1 1;
    text-align: center;
  }

  .search-wrapper {
    width: 100%;
  }

  .search-input {
    flex: 1 1;
  }

  .table-footer {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/DashboardPage.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA,uCAAuC,SAAS,EAAE;AAClD,uCAAuC,SAAS,EAAE;AAClD,uCAAuC,UAAU,EAAE;AACnD,uCAAuC,UAAU,EAAE;AACnD,uCAAuC,UAAU,EAAE;;AAEnD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,iCAAiC;EACjC,4CAA4C;EAC5C,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC,yBAAyB,UAAU,EAAE,EAAE,sCAAsC;AAC7E,yBAAyB,SAAS,EAAE,GAAG,2BAA2B;AAClE,yBAAyB,UAAU,EAAE,EAAE,gCAAgC;AACvE,yBAAyB,UAAU,EAAE,EAAE,0BAA0B;AACjE,yBAAyB,UAAU,EAAE,EAAE,0BAA0B;AACjE,yBAAyB,SAAS,EAAE,GAAG,qBAAqB;;AAE5D,kCAAkC;AAClC;EACE,mDAAmD;AACrD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,6DAA6D;EAC7D,yDAAmU;EACnU,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;;EAEE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;;EAEE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;AACF","sourcesContent":["/* DashboardPage Styles */\n\n.dashboard-page {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* Stats Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  gap: 1.5rem;\n}\n\n@media (min-width: 640px) {\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 1024px) {\n  .stats-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n.stat-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 1.25rem;\n  background-color: var(--surface-light);\n  border-radius: var(--radius-xl);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n}\n\n.stat-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-lg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.stat-icon .material-symbols-outlined {\n  font-size: 24px;\n}\n\n.stat-icon-primary {\n  background-color: var(--primary-light);\n  color: var(--primary);\n}\n\n.stat-icon-blue {\n  background-color: #dbeafe;\n  color: #2563eb;\n}\n\n.stat-icon-purple {\n  background-color: #f3e8ff;\n  color: #9333ea;\n}\n\n.stat-icon-green {\n  background-color: #dcfce7;\n  color: #16a34a;\n}\n\n.stat-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.stat-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n.stat-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-main);\n  margin: 0;\n}\n\n.rank-cell {\n  font-weight: 700;\n  color: var(--text-sub);\n  width: 4rem;\n  text-align: center;\n}\n\n.books-ranking-table th:nth-child(1) { width: 6%; }\n.books-ranking-table th:nth-child(2) { width: 8%; }\n.books-ranking-table th:nth-child(3) { width: 40%; }\n.books-ranking-table th:nth-child(4) { width: 28%; }\n.books-ranking-table th:nth-child(5) { width: 18%; }\n\n.reader-count-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--primary);\n}\n\n.reader-count-badge .material-symbols-outlined {\n  font-size: 16px;\n}\n\n/* Card */\n.card {\n  background-color: var(--surface-light);\n  border-radius: var(--radius-xl);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.5rem;\n  background-color: var(--slate-50);\n  border-bottom: 1px solid var(--border-color);\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.card-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--text-main);\n  margin: 0;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.filter-tabs {\n  display: flex;\n  gap: 0.25rem;\n  background-color: var(--slate-100);\n  padding: 0.25rem;\n  border-radius: var(--radius-lg);\n}\n\n.filter-tab {\n  padding: 0.375rem 0.75rem;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: var(--text-sub);\n  background-color: transparent;\n  border: none;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.filter-tab:hover {\n  color: var(--text-main);\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\n.filter-tab.active {\n  color: var(--primary);\n  background-color: var(--surface-light);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.search-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-wrapper .material-symbols-outlined {\n  position: absolute;\n  left: 0.75rem;\n  color: var(--text-sub);\n  font-size: 20px;\n}\n\n.search-input {\n  width: 16rem;\n  padding: 0.5rem 0.75rem 0.5rem 2.5rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  font-size: 0.875rem;\n  background-color: var(--surface-light);\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px var(--primary-light);\n}\n\n/* Table */\n.table-container {\n  overflow-x: auto;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.table thead {\n  background-color: var(--slate-50);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.table th {\n  padding: 1rem 1.5rem;\n  text-align: left;\n  font-weight: 600;\n  color: var(--text-sub);\n  text-transform: uppercase;\n  font-size: 0.75rem;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n}\n\n/* Column widths for Dashboard */\n.table th:nth-child(1) { width: 15%; } /* Borrower Name - large, multi-line */\n.table th:nth-child(2) { width: 8%; }  /* Cover - compact, fixed */\n.table th:nth-child(3) { width: 40%; } /* Title - largest, multi-line */\n.table th:nth-child(4) { width: 12%; } /* Borrow Date - compact */\n.table th:nth-child(5) { width: 12%; } /* Return Date - compact */\n.table th:nth-child(6) { width: 8%; }  /* Status - compact */\n\n/* Table row - consistent height */\n.table tbody tr {\n  transition: background-color var(--transition-fast);\n}\n\n.table tbody tr:hover {\n  background-color: var(--background-light);\n}\n\n/* Book cover column - center the image */\n.book-cover-column {\n  text-align: center;\n  vertical-align: middle !important;\n  padding: 0.75rem 0.75rem !important;\n}\n\n.book-cover-inline {\n  width: 48px;\n  height: 64px;\n  object-fit: cover;\n  border-radius: var(--radius-md);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  border: 1px solid var(--border-color);\n}\n\n.book-cover-placeholder-inline {\n  width: 48px;\n  height: 64px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-color);\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2364748b'%3E%3Cpath d='M4 6a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm2 0v12h12V6H6zm4 2a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1zm4 0a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1z'/%3E%3C/svg%3E\");\n  background-size: 24px;\n  background-repeat: no-repeat;\n  background-position: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.book-cover-placeholder-inline .material-symbols-outlined {\n  font-size: 24px;\n  color: #64748b;\n}\n\n.book-cover-column .book-cover-inline,\n.book-cover-column .book-cover-placeholder-inline {\n  margin: 0 auto;\n  display: block;\n}\n\n/* Book title column - allow wrapping */\n.book-title-column {\n  white-space: normal;\n  vertical-align: middle;\n  max-width: 300px;\n}\n\n.book-title-text {\n  word-break: break-word;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.table td {\n  padding: 0.75rem 1.25rem;\n  border-top: 1px solid var(--border-color);\n  color: var(--text-main);\n  vertical-align: middle;\n  height: 80px;\n  box-sizing: border-box;\n}\n\n/* Compact date cells */\n.table td:nth-child(4),\n.table td:nth-child(5) {\n  padding: 0.75rem 1rem;\n  font-size: 0.8125rem;\n  white-space: nowrap;\n}\n\n/* Borrower Name and Title cells - allow wrapping */\n.table td:nth-child(1),\n.table td:nth-child(3) {\n  white-space: normal;\n  vertical-align: middle;\n}\n\n/* Cover and Status cells - compact */\n.table td:nth-child(2),\n.table td:nth-child(6) {\n  white-space: nowrap;\n}\n\n/* Borrower Cell */\n.borrower-cell {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-weight: 500;\n  height: 100%;\n}\n\n.avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.avatar {\n  background-color: #e0e7ff;\n  color: #4338ca;\n}\n\n/* Status Badge */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.25rem 0.625rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  border-radius: var(--radius-full);\n  border: 1px solid;\n}\n\n.status-borrowed,\n.status-active {\n  background-color: #fee2e2;\n  color: #991b1b;\n  border-color: #fca5a5;\n}\n\n.status-returned {\n  background-color: #dcfce7;\n  color: #166534;\n  border-color: #86efac;\n}\n\n.status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: currentColor;\n}\n\n/* Table Footer */\n.table-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.5rem;\n  background-color: var(--slate-50);\n  border-top: 1px solid var(--border-color);\n}\n\n.pagination-info {\n  font-size: 0.875rem;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n.pagination-info strong {\n  color: var(--text-main);\n  font-weight: 600;\n}\n\n.pagination-buttons {\n  display: flex;\n  gap: 0.5rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .dashboard-page {\n    gap: 1rem;\n    padding: 0.5rem;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .card-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .header-actions {\n    width: 100%;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .filter-tabs {\n    width: 100%;\n  }\n\n  .filter-tab {\n    flex: 1;\n    text-align: center;\n  }\n\n  .search-wrapper {\n    width: 100%;\n  }\n\n  .search-input {\n    flex: 1;\n  }\n\n  .table-footer {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
